// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1avpp","content":"LoadingAlert_content__1e_Hc"};